import { Outlet } from "react-router-dom";
import { sidebarListSupplier } from "../../constants/sidebarList";
import { ProtectedRoute } from "../../middleware/ProtectedRoute";
import { ContentDashboardContainer } from "../container/ContentDashboardContainer";
import { DashboardContainer } from "../container/DashboardContainer";

export const LayoutDashboardSupplier = () => {
  return (
    <ProtectedRoute userType="supplier">
      <DashboardContainer data={sidebarListSupplier} pageRoot="/supplier">
        <ContentDashboardContainer>
          <Outlet />
        </ContentDashboardContainer>
      </DashboardContainer>
    </ProtectedRoute>
  );
};
